

type Props={
    pageName:string;
    pageDesc:string;
    isSearch:boolean;
    isAdd?:boolean;
    btnIcon?:string;
    AddText?:string;
    addEvent?:()=>void;
}
 
const Title=({pageName,pageDesc,isSearch,isAdd,AddText,addEvent,btnIcon="add"}:Props)=>{
    return <>
      {/* Header Section */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-margin-mobile">
          <div className="flex flex-col">
            <h1 className="font-headline-md text-headline-md text-on-surface">
              {pageName}
            </h1>
            <p className="font-body-md text-body-md text-on-surface-variant mt-1">
              {pageDesc}
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-unit w-full md:w-auto">
            {/* Search & Filters */}
           {isSearch&&(<div className="flex bg-surface-container rounded-full px-4 py-2 flex-grow sm:flex-grow-0 min-w-[280px]">
              <span className="material-symbols-outlined text-on-surface-variant ml-2">
                search
              </span>
              <input
                className="bg-transparent text-body-sm font-body-sm text-on-surface outline-none w-full placeholder-on-surface-variant"
                placeholder="البحث عن مستخدم..."
                type="text"
              />
            </div>)}
            {isSearch&&(<button className="bg-surface-container hover:bg-surface-container-high transition-colors text-on-surface font-label-md text-label-md px-4 py-2 rounded-full flex items-center justify-center gap-2">
              <span className="material-symbols-outlined text-lg">
                filter_list
              </span>
              <span className="">تصفية</span>
            </button>)}
          {isAdd&&(  <button onClick={addEvent} className="bg-vibrant-orange hover:bg-secondary-container transition-colors text-on-primary font-label-md text-label-md px-6 py-2 rounded-full flex items-center justify-center gap-2 shadow-md">
              <span className="material-symbols-outlined text-lg">{btnIcon}</span>
              <span className="">  {AddText}</span>
            </button>)}
          </div>
        </div>
    </>
}
export default Title;